// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2HHHE","log":"ModalInventoryLogs_log__27Uc_","date":"ModalInventoryLogs_date__fhQXo","userName":"ModalInventoryLogs_userName__lLepz"};